module.exports = __webpack_public_path__ + "assets/img/router_children.3fbc0552.jpg";